import { render, staticRenderFns } from "./4.vue?vue&type=template&id=39a9669b&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=39a9669b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a9669b",
  null
  
)

export default component.exports